import DistanceUnit from './distance-unit-component';

import './distance-unit.scss';

const MODULE_NAME = 'app.hotels-distance-unit';
const module = angular.module(MODULE_NAME, [])
    .directive(DistanceUnit.DIRECTIVE_NAME, DistanceUnit);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/distance-unit/distance-unit-module.js